import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-secondary-layout',
  templateUrl: './secondary-layout.component.html',
  styleUrl: './secondary-layout.component.scss'
})
export class SecondaryLayoutComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    //theme js function lazyload after component
    (window as any).W3Crm.init(); 

  }

}
